import { render } from "./Left12.vue?vue&type=template&id=773d8d82&scoped=true"
import script from "./Left12.vue?vue&type=script&lang=js"
export * from "./Left12.vue?vue&type=script&lang=js"

import "./Left12.vue?vue&type=style&index=0&id=773d8d82&scoped=true&lang=css"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773d8d82"]])

export default __exports__